const calculateNetRecurringBenefit = (initiative) => {
  if (!initiative.impact || !Array.isArray(initiative.impact)) return 0;

  return initiative.impact.reduce((acc, impact) => {
    if (impact.frequencyAndDirection && impact.frequencyAndDirection.startsWith('Recurring')) {
      let amount = 0; // Initialize amount to 0

      // Check if annualizedValues.plan exists and is a number or an array
      if (typeof impact?.annualizedValues?.plan === 'number') {
        amount = impact.annualizedValues.plan; // Use the value directly if it's a number
      } else if (Array.isArray(impact?.annualizedValues?.plan)) {
        // If it's an array, then reduce it as before
        amount = impact.annualizedValues.plan.reduce((sum, val) => sum + (val || 0), 0);
      } else {
        // Handle cases where it might be undefined, null, or something else unexpected
        // For robustness, you might want to log a warning here if this happens often.
        amount = 0;
      }

      if (impact.frequencyAndDirection.includes('Benefit')) {
        acc += amount;
      } else if (impact.frequencyAndDirection.includes('Negative')) {
        acc -= amount;
      }
    }
    return acc;
  }, 0);
};

export default calculateNetRecurringBenefit;